import omitBy from 'lodash/omitBy';

export function omitUndefined<T extends object>(obj: T): Partial<T> {
  return omitBy(obj, (val) => val === undefined);
}
